import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useTopics } from '../contexts/TopicsContext';
import '../styles/components/layout/topics-sidebar.css';

export default function TopicSidebar() {
  const topicsResult = useTopics();
  const topics = topicsResult?.topics || {};
  const loading = topicsResult?.loading || false;
  const completedQuestions = topicsResult?.completedQuestions || [];
  const incompleteQuestions = topicsResult?.incompleteQuestions || [];
  const navigate = useNavigate();
  const location = useLocation();
  
  // Initialize expandedTopics from sessionStorage
  const [expandedTopics, setExpandedTopics] = useState(() => {
    const saved = sessionStorage.getItem("expandedTopics");
    return saved ? new Set(JSON.parse(saved)) : new Set();
  });

  const toggleExpanded = (topic, event) => {
    if (event) event.stopPropagation();
    setExpandedTopics((prev) => {
      const newSet = new Set(prev)
      if (newSet.has(topic)) {
        newSet.delete(topic)
      } else {
        newSet.add(topic)
      }
      // Persist to sessionStorage
      sessionStorage.setItem("expandedTopics", JSON.stringify([...newSet]));
      return newSet
    })
  }

  const navigateToQuestion = (question, topic) => {
    sessionStorage.setItem("selectedTopic", topic)
    navigate(`/question/${question.questionID}`)
  }

  useEffect(() => {
    if (location.pathname === "/dashboard") {
      sessionStorage.removeItem("selectedTopic")
    }
  }, [location.pathname])

  useEffect(() => {
    if (location.pathname === "/dashboard") {
      sessionStorage.removeItem("selectedTopic");
    }
  }, [location.pathname]);
  
  return (
    <div className="topics-sidebar">
      <nav>
        <h3 className="topics-sidebar-heading">Problem Set {loading && "(loading...)"}</h3>
        <ul className="topics-list">
          {Object.keys(topics)
            .filter((topic) => topics[topic][0] != null)
            .sort((a, b) => a.localeCompare(b))
            .map((topic) => (
              <li key={topic} className="topic-item">
                <div className="topic-header">
                  <Button
                    onClick={() => toggleExpanded(topic)}
                    className={`topic-button ${expandedTopics.has(topic) ? 'expanded' : ''}`}
                    variant="outline-primary"
                  >
                    <span className="topic-name">{topic}</span>
                    <span className="topic-chevron">{expandedTopics.has(topic) ? "▼" : "▶"}</span>
                  </Button>
                </div>

                {expandedTopics.has(topic) && (
                  <div className="topic-problems">
                    {topics[topic]
                      .filter((question) => question != null)
                      .map((question, index) => {
                        const isCompleted = completedQuestions.includes(question.questionID);
                        const isIncomplete = incompleteQuestions.includes(question.questionID);
                        const statusClass = isCompleted? 'completed': isIncomplete? 'incomplete': 'not-attempted';
                        return (
                          <div key={question.questionID} className="problem-item">
                            <span
                              className={`problem-status-dot ${statusClass}`}
                            />
                            <button
                              onClick={() => navigateToQuestion(question, topic)}
                              className="problem-button"
                            >
                              {question.functionName || `Problem ${index + 1}`}
                            </button>
                          </div>
                        );
                      })}
                  </div>
                )}
              </li>
            ))}
        </ul>
      </nav>
    </div>
  );
}